'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDoNotDisturbOff = function MdDoNotDisturbOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11.6 21.6h5.8l-3.3-3.2h-2.5v3.2z m-7.8-17.8l32.5 32.5-2.2 2.1-4.6-4.7c-2.7 1.8-6 2.9-9.5 2.9-9.2 0-16.6-7.4-16.6-16.6 0-3.5 1.1-6.8 2.9-9.5l-4.7-4.6z m24.6 14.6h-5.8l-12-12.1c2.6-1.8 5.9-2.9 9.4-2.9 9.2 0 16.6 7.4 16.6 16.6 0 3.5-1.1 6.8-2.9 9.5l-7.8-7.9h2.5v-3.2z' })
        )
    );
};

exports.default = MdDoNotDisturbOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/do-not-disturb-off.js
// module id = 1444
// module chunks = 168707334958949